import Footer from '@components/common/footer'
import NavBar from '@components/common/navbar'
import EditInfoButton from '@components/profile/edit-info-button'
import Competitions from '@components/profile/student/competitions'
import StudentDetails from '@components/profile/student/details'
import Projects from '@components/profile/student/projects'
import StudentStats from '@components/profile/student/stats'
import TeacherProfile from '@components/profile/teacher'
import BecomeTeacherCTA from '@components/profile/teacher/become-teacher-cta'
import { ProfileContextProvider } from '@contexts/profile'
import { useSessionContext } from '@contexts/session'
import { ProfileDetailsType } from '@lib/types/profile'
import { NextSeo } from 'next-seo'
import router from 'next/router'
import { useMemo } from 'react'
import { ChevronLeft } from 'react-feather'

type Props = {
  profileDetails: ProfileDetailsType
}

const ProfilePage = ({ profileDetails }: Props) => {
  const { username } = useSessionContext()
  const isEditable = useMemo(() => username === profileDetails?.username, [])
  const isTeacher = profileDetails?.role === 'teacher'
  const teacher = profileDetails?.teacher

  const handleBecomeTeacher = () => {
    router.push('/teach/')
  }

  const title = isTeacher
    ? `${profileDetails?.name || 'Meet your teacher'} — ${
        teacher?.subtitle || 'Instructor at Codingal'
      } on Codingal`
    : profileDetails?.name || 'Online Coding class for Kids'

  const description = isTeacher
    ? teacher?.about?.slice(0, 160) ||
      'Codingal is on a mission to provide coding education to every K-12 student.'
    : 'Codingal is on a mission to provide coding education to every K-12 student. Online coding classes for kids with expert teachers and engaging curriculum.'

  return (
    <>
      <NextSeo title={title} description={description} />
      <NavBar />
      <ProfileContextProvider value={profileDetails}>
        {isTeacher ? (
          <TeacherProfile />
        ) : (
          <div className="bg-grey-100 p-5">
            <div className="max-w-6xl mx-auto grid gap-6 mb-10">
              <div className="flex items-center justify-between">
                <button
                  className="text-orange hover:underline focus:outline-none font-600 flex items-center"
                  onClick={() =>
                    isEditable ? router.back() : router.push('/dashboard')
                  }
                >
                  <ChevronLeft />
                  <span>Back to dashboard</span>
                </button>
                {isEditable && <EditInfoButton />}
              </div>
              <StudentDetails isEditable={isEditable} />
              <StudentStats />
              <Competitions competitionType="hackathons" />
              <Competitions competitionType="coding-contests" />
              <Projects projectType="projects" />
              <Projects projectType="assignments" />
            </div>
          </div>
        )}
      </ProfileContextProvider>
      {isTeacher && (
        <div className="bg-grey-100 px-5 pb-10">
          <BecomeTeacherCTA onApply={handleBecomeTeacher} />
        </div>
      )}
      <Footer />
    </>
  )
}
export default ProfilePage
